__turbopack_context__.v({
  "className": "radiumsansfont_9d9511d-module__0xyIHa__className",
  "variable": "radiumsansfont_9d9511d-module__0xyIHa__variable",
});
